<template>
    <div>
        <!-- show modal for review -->
        <div
                class="modal fade"
                id="deals-widget-twitter"
                tabindex="-1"
                role="dialog"
                aria-labelledby="deals-widget-twitter"
                aria-hidden="true"
        >
            <div class="modal-dialog window-popup edit-widget edit-widget-twitter" role="document">
                <div class="modal-content" ref="searchContent">
                    <a href="#" class="close icon-close" data-dismiss="modal" aria-label="Close">
                        <svg class="olymp-close-icon">
                            <use xlink:href="/svg-icons/sprites/icons.svg#olymp-close-icon" />
                        </svg>
                    </a>

                    <div class="modal-header">
                        <h6 class="title">Select a match to post a Deal For</h6>
                    </div>

                    <div class="modal-body">
                        <input
                                class="form-control"
                                id="searchMatch"
                                name="searchMatch"
                                @keyup="getFixtures"
                                v-model="searchMatch"
                                placeholder="Search Match"
                        />
                        <div class="population">
                            <div class="hide" id="tg" style="width:100%;text-align:center">
                                <img style="" src="/image/lg.gooey-ball-lodaer.gif" width="60" />
                            </div>
                            <div class="versus" v-for="(searchResults, index) in searchResult" :key="index">
                                <div
                                        class="row dll"
                                        :id="setMatchId(searchResults.id)"
                                        @click="selectMatch(searchResults.id)"
                                >
                                    <div class="col">
                                        <div
                                                v-if="searchResults.home_team_logo === '' || searchResults.home_team_logo === 'undefined' "
                                                class="versus-img"
                                        ></div>
                                        <div class="versus-img">
                                            <img :src="searchResults.home_team_logo" />
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="caption">
                                            <div v-if="searchResults.is_past === true" class="badge bg-info">Old Match</div>
                                            <h5>VS</h5>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div
                                                v-if="searchResults.away_team_logo === '' || searchResults.away_team_logo === 'undefined' "
                                                class="versus-img"
                                        ></div>
                                        <div class="versus-img">
                                            <img :src="searchResults.away_team_logo" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                                id="matchBButton"
                                @click="setMatch()"
                                data-toggle="modal"
                                data-target="#deals-my-poll-popup"
                                disabled
                                class="btn bg-twitter btn-lg full-width btn-icon-left"
                        >Select Match</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import jquery from "jquery";
    // var $ = jquery;

    export default {
        data() {
            return {
                searchMatch: "",
                searchResult: {},
                matchId: "",
                errorData: {}
            };
        },
        methods: {
            showLoading() {
                let loader = this.$loader(this, this.$refs.searchContent, {
                    loaderType: "spinner"
                });
                return loader;
            },
            // search for matchs to post review on
            getFixtures() {
                let query = this.searchMatch;
                $("#tg").removeClass("hide");
                this.axios
                    .get("fixtures/search/" + query)
                    .then(response => {
                        $("#tg").addClass("hide");
                        // console.log(response.data.data);
                        this.searchResult = response.data.data.fixtures;
                    })
                    .catch(error => {
                        $("#tg").addClass("hide");
                        // console.log(error.response);
                    });
            },
            setMatchId(id) {
                return "match_" + id;
            },
            // select the match to post review on
            selectMatch(matchId, selected = false) {
                // console.log(matchId);
                this.matchId = matchId;
                $("#matchBButton").attr("disabled", false);
                $(".dll").removeClass("selected");
                $("#match_" + matchId).addClass("selected");
            },
            // set the details of the selected match
            setMatch() {
                var matchId = this.matchId;
                window.eventBus.$emit("dealsMatchID", matchId);
            }

        },
        mounted() {
            window.eventBus.$on("dealsBox", id => {
                if (id === true) {
                    $("#deals-widget-twitter").modal("show");
                }
            });

        },
    }
</script>

<style>

</style>
